<script lang="ts">
	import { maxNumber, maxNumbers, minNumber } from "../../../../core/schema/productOptionsConstants.js";
	import cross from "../../../../core/assets/icons/cross.svg?raw";
	import { inflectNumberCountAccusative } from "./inflectNumberCount.js";
	import NumberInput from "../Form/NumberInput.svelte";
	import Icon from "../Icon.svelte";
	import type { ProductNumber } from "../../../../core/schema/ProductNumber.js";
	import plus from "../../../../core/assets/icons/btn-plus.svg?raw";
	import Button from "../Button.svelte";
	import cislodort from "../../../../core/assets/icons/cislodort.svg";
	import { inflectFit } from "./inflectFit.js";
	import ProductOptionHeader from "./ProductOptionHeader.svelte";
	import { ProductOption } from "../../../../core/schema/ProductOption.js";
	import { calculatePriceForProductOption } from "../../../../core/schema/utils/calculatePriceForProductOption.js";

	export let numbers: ProductNumber[];
	export let updateNumbers: (numbers: ProductNumber[]) => void;
	export let basePrice: number | undefined;
	export let minimalPricesForOptions: Record<ProductOption, number>;
	export let minimalPriceIsFinal = false;

	let newNumbers = structuredClone(numbers);

	function addNumber(): void {
		newNumbers.push({ id: crypto.randomUUID(), number: 0 });
		newNumbers = newNumbers;
	}

	function removeNumber(idToRemove: string): void {
		newNumbers = newNumbers.filter(({ id }) => id !== idToRemove);
	}

	$: minimalPrice = minimalPricesForOptions[ProductOption.Numbers];
	$: currentPrice =
		basePrice !== undefined
			? calculatePriceForProductOption(basePrice, ProductOption.Numbers, newNumbers)
			: minimalPrice;
	$: numbersLeft = maxNumbers - newNumbers.length;

	let firstNumberIsForced = true;

	function forceFirstNumber(numbers: ProductNumber[]): void {
		if (numbers.length === 0 && firstNumberIsForced) {
			addNumber();
			firstNumberIsForced = false;
		}
	}

	$: forceFirstNumber(newNumbers);
</script>

<ProductOptionHeader
	name="Čokoládová číslice"
	image={cislodort}
	price={currentPrice}
	{minimalPrice}
	{minimalPriceIsFinal}
>
	<div>
		Používáme čokoládové číslice z bílé nebo hořké čokolády, které si sami vyrábíme. Naše cukrářky zvolí daný druh
		číslic s ohledem na to, aby s vaším dortem ladily.
	</div>
</ProductOptionHeader>
<div class="grid w-full grid-cols-[auto,1fr] items-center gap-x-3 gap-y-2">
	{#each newNumbers as { id, number }, index (id)}
		<span class="text-base font-semibold leading-5">{index + 1}.</span>
		<div class="flex w-full gap-2">
			<NumberInput
				id="number-{id}"
				class="flex-1 !gap-1"
				min={minNumber}
				max={maxNumber}
				required
				bind:valueAsNumber={number}
			/>

			<button
				type="button"
				on:click={() => {
					removeNumber(id);
				}}
			>
				<Icon
					icon={cross}
					class="hover:text-secondary-300 text-secondary-250 aspect-square h-3 cursor-pointer transition-colors duration-300"
				/>
			</button>
		</div>
	{/each}
</div>
<div class="flex flex-col">
	{#if numbersLeft > 0}
		<div class="text-2xs mt-2">
			<p>Na produkt se {inflectFit(numbersLeft)} ještě {numbersLeft} číslice</p>
			<button type="button" on:click={addNumber} class="mt-1 underline">
				Přidat {inflectNumberCountAccusative[newNumbers.length + 1]} číslici
			</button>
		</div>
	{/if}
	<Button
		icon={plus}
		iconClass="w-5 h-5"
		class="mt-4 self-end"
		on:click={() => {
			updateNumbers(newNumbers);
		}}>Přidat úpravu</Button
	>
</div>
